subscription updateFootball($event: String) {
    updateFootball(event: $event)
}
